import { CreatedByRelationship } from './Common'

export const prequalificationMapSF = {
  direction: 'in',
  ...CreatedByRelationship,
  Id: 'id',
  Stage__c: 'stage'
}

export interface Prequalification {
  stage: string
  id: string
}
